import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAnalytics } from '../contexts';

export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  const { push } = useAnalytics();

  useEffect(() => {
    push([
      '_trackPageview',
      null,
      null,
      pathname,
      null,
      null,
      window.document.title,
    ]);
  }, [location, location.pathname]);

  return null;
}
